module.exports = __webpack_public_path__ + "static/media/inner_fabric_cuff.9a3e995b.svg";